export default "__VITE_ASSET__C$ksHQb5__"